import { render, staticRenderFns } from "./LoanableCarousel.vue?vue&type=template&id=f208480a"
import script from "./LoanableCarousel.vue?vue&type=script&lang=js"
export * from "./LoanableCarousel.vue?vue&type=script&lang=js"
import style0 from "./LoanableCarousel.vue?vue&type=style&index=0&id=f208480a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports